<template>
  <el-drawer
    class="edit-drawer"
    :title="opts.single ? '编辑图片' : '批量编辑图片'"
    size="85%"
    :wrapperClosable="false"
    :show-close="false"
    :visible.sync="visible"
    @close="handleClose"
  >
    <iframe v-if="visible" ref="imageEditor" id="imageEditor" frameborder="0" width="100%" height="100%" />
  </el-drawer>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {},
  data() {
    return {
      visible: false,
      opts: { imgUrlList: [] },
      latte: null
    };
  },
  computed: {
    ...mapGetters(['imagePimToken']),
  },
  methods: {
    ...mapActions(['getPimToken']),
    async method_open(opts) {
      this.visible = true;
      this.opts = opts || {};

      await this.getPimToken()
      this.$nextTick(() => {
        this.newLatteSDK();
      })
    },
    async newLatteSDK() {
      const tasks = (this.opts.tasks || []).map(item => {
        const backgroundImage = item.backgroundImage.replace('mmecimage.cn', 'mmecimage.superboss.cc')
        return {...item, backgroundImage}
      })
      const latte = new LatteSDK({
        functionCode: 'default',
        title: '图片编辑',
        token: this.imagePimToken,
        environment: {
          // menu_config: [
          //   ['save', '保 存'],
          //   ['download', '下载至电脑'],
          // ],
          aside_menu: [
            'resourceTodo',  // 待办 如果当前打开编辑器为任务队列则即使未配置待办导航也会渲染待办导航
            // 'resourceImage', // 图片
            'resourceText', //文字
            'resourceBackground', //背景
            'resourceTemplate', 	// 模板
            'resourceMaterial', // 素材
            'resourceComponent', //组件
            'resourceMy' //我的
          ]
        },
        tasks,
        beforeLoad: () => {
          // alert('任务开始加载');
        },
        script: `app.aside.open('resourceTodo');${this.opts.isCrop ? 'app.component.triggerImageCrop();' : ''}`,
      });
      latte.$on('close', this.onLatteClose.bind(this));
      latte.$on('save', this.onLatteSave.bind(this));
      latte.$on('saveAs', this.onLatteSaveAs.bind(this));
      // 配置就绪后，调用 init 方法，将正式唤起编辑器
      // 运行容器支持 iframe 和 window 两种
      // iframe: 在你指定 id 的 iframe 加载
      // window: 新开浏览器 tab
      latte.init('iframe', 'imageEditor');
      this.latte = latte
      // latte.init('window')
    },
    // 保存
    onLatteSave(v) {
      console.log('保存', v);
      const urls = v.taskResults.map((item, index) => {
        return item.hasChange ? item.url : this.opts.tasks[index]?.backgroundImage
      });
      this.opts.okFn && this.opts.okFn(urls);
      this.handleClose()
    },
    // 另存为
    onLatteSaveAs() {
      console.log('另存为');
    },
    // 关闭
    onLatteClose() {
      this.handleClose()
    },
    /** 取消按钮关闭弹窗 */
    handleClose() {
      this.visible = false;
      this.opts = {};
      this.latte = null
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-drawer {
  ::v-deep .el-drawer__header {
    margin-bottom: 0px;
    font-size: 18px;
    font-weight: 700;
    color: #3e4144;
  }
  ::v-deep .el-drawer__body {
    padding: 10px 20px;
  }
}
</style>